/* eslint-disable no-unused-vars */

export enum ROLE {
  ADMIN = 'ADMIN',
  TENANT = 'TENANT',
  TENANT_MARKETING = 'TENANT_MARKETING',
  TENANT_IT = 'TENANT_IT',
  TENANT_FINANCE = 'TENANT_FINANCE',
  TENANT_MANAGEMENT = 'TENANT_MANAGEMENT',
  TENANT_PR = 'TENANT_PR',
  ACCOMMODATION = 'ACCOMMODATION',
  ACCOMMODATION_OPERATOR = 'ACCOMMODATION_OPERATOR',
  SERVICE = 'SERVICE',
  CHANNEL = 'CHANNEL',
  CHANNEL_ADMIN = 'CHANNEL_ADMIN',
  PMS_SERVICE = 'PMS_SERVICE',
  PROVIDER = 'PROVIDER'
}

export const allRoles: ROLE[] = [
  ROLE.ADMIN,
  ROLE.TENANT,
  ROLE.TENANT_MARKETING,
  ROLE.TENANT_IT,
  ROLE.TENANT_FINANCE,
  ROLE.TENANT_MANAGEMENT,
  ROLE.TENANT_PR,
  ROLE.ACCOMMODATION,
  ROLE.ACCOMMODATION_OPERATOR,
  ROLE.SERVICE,
  ROLE.CHANNEL,
  ROLE.CHANNEL_ADMIN,
  ROLE.PMS_SERVICE,
  ROLE.PROVIDER
]

export type RouteWithAccessType = {
  route: string
  exact: boolean
  rolesListWithReadAccess: ROLE[]
  rolesListWithWriteAccess: ROLE[]
  component: React.ComponentType<any>
  tabs?: {
    params: Record<string, string>
    rolesListWithReadAccess: ROLE[]
    rolesListWithWriteAccess: ROLE[]
    sections?: Record<
      string,
      {
        rolesListWithReadAccess: ROLE[]
        rolesListWithWriteAccess: ROLE[]
      }
    >
  }[]
  sections?: Record<
    string,
    {
      rolesListWithReadAccess: ROLE[]
      rolesListWithWriteAccess: ROLE[]
    }
  >
}
